import { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Button, Select, Switch } from 'antd';
import styles from './qRCodeRegionModifier.module.less';
import { ElementData } from '@/base/ElementData/ElementData';
import QRCodeRegionContent from '@/base/ElementData/QRCodeRegionContent';
import MediaFileSelectorModifier from '../MediaFileSelectorModifier/MediaFileSelectorModifier';

const { TextArea } = Input;

interface QRCodeRegionModifierProps {
    focusedItem: ElementData<QRCodeRegionContent>;
    onInputChange: (id: number, key: string, value: any) => void;
    changeZIndex: (id: number, type: string) => void;
};


const CodeRegionModifier: React.FC<QRCodeRegionModifierProps> = ({
    focusedItem,
    onInputChange,
    changeZIndex
}) => {

    //修改focusedItem.content.payload,这个payload是一个对象，包含了二维码的信息
    const handlePayloadChange = (key: string, value: any) => {
        const newPayload = { ...focusedItem.content.payload, [key]: value };
        onInputChange(focusedItem.id, 'payload', newPayload);
    }

    return (
        <div>
            <div className={styles.modifyItem}>
                <div className={styles.modifyItemTitle}>宽</div>
                <Input
                    type="number"
                    value={focusedItem.content.width}
                    onChange={e => onInputChange(focusedItem.id, 'width', e.target.value)}
                />
                <div className={styles.modifyItemTitle}>高</div>
                <Input
                    type="number"
                    value={focusedItem.content.height}
                    onChange={e => onInputChange(focusedItem.id, 'height', e.target.value)}
                />
            </div>
            <div className={styles.modifyItem}>
                <div className={styles.modifyItemTitle}>生成二维码方式</div>
                <Select
                    value={focusedItem.content.qrCodeType}
                    onChange={value => onInputChange(focusedItem.id, 'qrCodeType', value)}
                >
                    <Select.Option value="preset">预设二维码链接</Select.Option>
                    <Select.Option value="generate">实时生成链接</Select.Option>
                </Select>
            </div>
            {focusedItem.content.qrCodeType === 'preset' && (
                <div className={styles.modifyItem}>
                    <div className={styles.modifyItemTitle}>二维码链接</div>
                    <Input
                        type="text"
                        value={focusedItem.content.src}
                        onChange={e => onInputChange(focusedItem.id, 'src', e.target.value)}
                    />
                </div>
            )}
            {
                focusedItem.content.qrCodeType === 'generate' && (
                    <>
                        <div className={styles.modifyItem}>
                            <div className={styles.modifyItemTitle}>分享类型</div>
                            <Select
                                value={focusedItem.content.shareType}
                                onChange={value => onInputChange(focusedItem.id, 'shareType', value)}
                                className={styles.largeSelect}
                            >
                                <Select.Option value="music">音乐</Select.Option>
                                <Select.Option value="code">代码</Select.Option>
                                <Select.Option value="cyberAvatar">赛博头像</Select.Option>
                                <Select.Option value="basicPost">通用图文</Select.Option>
                                <Select.Option value="basicWithSound">图文(播放声音)</Select.Option>
                                <Select.Option value="chatAgent">聊天智能体</Select.Option>
                                <Select.Option value="multiImages">多图文(6图)</Select.Option>
                            </Select>
                        </div>
                        {
                            focusedItem.content.shareType === 'code' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>代码</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.srcCode}
                                            onChange={e => handlePayloadChange('srcCode', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>语言</div>
                                        <Select
                                            value={focusedItem.content.payload?.language}
                                            onChange={value => handlePayloadChange('language', value)}
                                        >
                                            <Select.Option value="html">HTML</Select.Option>
                                            <Select.Option value="python">Python</Select.Option>
                                        </Select>
                                    </div>
                                </>
                            )
                        }
                        {
                            focusedItem.content.shareType === 'cyberAvatar' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>头像url</div>
                                        <Input
                                            type="text"
                                            value={focusedItem.content.payload?.avatar_url}
                                            onChange={e => handlePayloadChange('avatar_url', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>name</div>
                                        <Input
                                            type="text"
                                            value={focusedItem.content.payload?.name}
                                            onChange={e => handlePayloadChange('name', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>tagline</div>
                                        <Input
                                            type="text"
                                            value={focusedItem.content.payload?.tagline}
                                            onChange={e => handlePayloadChange('tagline', e.target.value)}
                                        />
                                    </div>
                                </>
                            )
                        }
                        {
                            focusedItem.content.shareType === 'basicPost' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>文字 Title</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.title}
                                            onChange={e => handlePayloadChange('title', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>文字 body</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.body}
                                            onChange={e => handlePayloadChange('body', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图像 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl}
                                            onChange={e => handlePayloadChange('imgUrl', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>背景样式</div>
                                        <Select
                                            value={focusedItem.content.payload?.backgroundStyle}
                                            onChange={value => handlePayloadChange('backgroundStyle', value)}
                                            className={styles.largeSelect}
                                        >
                                            <Select.Option value="blue">蓝色</Select.Option>
                                            <Select.Option value="orange">橙色</Select.Option>
                                        </Select>
                                    </div>
                                </>
                            )
                        }
                        {
                            focusedItem.content.shareType === 'basicWithSound' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>标题</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.title}
                                            onChange={e => handlePayloadChange('title', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content}
                                            onChange={e => handlePayloadChange('content', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图像 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl}
                                            onChange={e => handlePayloadChange('imgUrl', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>分享描述</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.shareDescription}
                                            onChange={e => handlePayloadChange('shareDescription', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容区域背景颜色</div>
                                        <Select
                                            value={focusedItem.content.payload?.contentBackgroundColor}
                                            onChange={value => handlePayloadChange('contentBackgroundColor', value)}
                                            className={styles.largeSelect}
                                        >
                                            <Select.Option value="white">白色</Select.Option>
                                            <Select.Option value="transparent">透明</Select.Option>
                                        </Select>
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容区域对齐方式</div>
                                        <Select
                                            value={focusedItem.content.payload?.contentTextAlign}
                                            onChange={value => handlePayloadChange('contentTextAlign', value)}
                                            className={styles.largeSelect}
                                        >
                                            <Select.Option value="left">左对齐</Select.Option>
                                            <Select.Option value="center">居中</Select.Option>
                                            <Select.Option value="right">右对齐</Select.Option>
                                        </Select>
                                    </div>
                                </>
                            )
                        }
                        {
                            focusedItem.content.shareType === 'chatAgent' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>systemPrompt</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.systemPrompt}
                                            onChange={e => handlePayloadChange('systemPrompt', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>agentAvatar</div>
                                        <MediaFileSelectorModifier
                                            mediaType={'images'}
                                            afterSelectionCallback={url => handlePayloadChange('agentAvatar', url)}
                                            btnText={'图片'}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <Input
                                            type="text"
                                            value={focusedItem.content.payload?.agentAvatar}
                                            onChange={e => handlePayloadChange('agentAvatar', e.target.value)}
                                            placeholder='智能体头像url'
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>标题</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.headerText}
                                            onChange={e => handlePayloadChange('headerText', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>预设消息</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.presetMessage}
                                            onChange={e => handlePayloadChange('presetMessage', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>分享描述</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.shareDescription}
                                            onChange={e => handlePayloadChange('shareDescription', e.target.value)}
                                        />
                                    </div>
                                </>
                            )
                        }
                        {
                            focusedItem.content.shareType === 'multiImages' && (
                                <>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>标题</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.title}
                                            onChange={e => handlePayloadChange('title', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容1</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content1}
                                            onChange={e => handlePayloadChange('content1', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片1 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl1}
                                            onChange={e => handlePayloadChange('imgUrl1', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容2</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content2}
                                            onChange={e => handlePayloadChange('content2', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片2 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl2}
                                            onChange={e => handlePayloadChange('imgUrl2', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容3</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content3}
                                            onChange={e => handlePayloadChange('content3', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片3 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl3}
                                            onChange={e => handlePayloadChange('imgUrl3', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容4</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content4}
                                            onChange={e => handlePayloadChange('content4', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片4 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl4}
                                            onChange={e => handlePayloadChange('imgUrl4', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容5</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content5}
                                            onChange={e => handlePayloadChange('content5', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片5 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl5}
                                            onChange={e => handlePayloadChange('imgUrl5', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容6</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.content6}
                                            onChange={e => handlePayloadChange('content6', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>图片6 url</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.imgUrl6}
                                            onChange={e => handlePayloadChange('imgUrl6', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>分享描述</div>
                                        <TextArea
                                            value={focusedItem.content.payload?.shareDescription}
                                            onChange={e => handlePayloadChange('shareDescription', e.target.value)}
                                        />
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容区域背景颜色</div>
                                        <Select
                                            value={focusedItem.content.payload?.contentBackgroundColor}
                                            onChange={value => handlePayloadChange('contentBackgroundColor', value)}
                                            className={styles.largeSelect}
                                        >
                                            <Select.Option value="white">白色</Select.Option>
                                            <Select.Option value="transparent">透明</Select.Option>
                                        </Select>
                                    </div>
                                    <div className={styles.modifyItem}>
                                        <div className={styles.modifyItemTitle}>内容区域对齐方式</div>
                                        <Select
                                            value={focusedItem.content.payload?.contentTextAlign}
                                            onChange={value => handlePayloadChange('contentTextAlign', value)}
                                            className={styles.largeSelect}
                                        >
                                            <Select.Option value="left">左对齐</Select.Option>
                                            <Select.Option value="center">居中</Select.Option>
                                            <Select.Option value="right">右对齐</Select.Option>
                                        </Select>
                                    </div>
                                </>
                            )
                        }
                    </>
                )
            }
            <div className={styles.modifyItem}>
                <Button onClick={() => changeZIndex(focusedItem.id, 'front')}>置于顶层</Button>
                <Button onClick={() => changeZIndex(focusedItem.id, 'back')}>置于底层</Button>
            </div>
        </div>
    )
};

export default CodeRegionModifier;